"use client";

// app/layout.js
import React, { useEffect } from "react";
import { Poppins } from "next/font/google";

// ========= Importación de estilos Bootstrap y plugins =========
import "bootstrap/scss/bootstrap.scss";
import "../public/css/plugins/feature.css";
import "../public/css/plugins/fontawesome-all.min.css";
import "../public/css/plugins/animation.css";
import "sal.js/dist/sal.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-tooltip/dist/react-tooltip.css";
// Importación de estilos principales SCSS
import "../public/scss/style.scss";

import ClientProviders from "./clientProviders";

const poppins = Poppins({
  subsets: ["latin"],
  weight: ["100", "200", "300", "400", "500", "600", "700", "800"],
});

export default function RootLayout({ children }) {
  useEffect(() => {
    require("bootstrap/dist/js/bootstrap.bundle.min.js");
  }, []);

  return (
    <html lang="es">
      <head>
        <link rel="icon" href="/images/icons/icon.svg" />
      </head>
      <body className={poppins.className} suppressHydrationWarning={true}>
        <ClientProviders>{children}</ClientProviders>
      </body>
    </html>
  );
}
